import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import "./new.css";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Button } from "react-bootstrap";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";
import { path } from "../../../order_managment/constants/apiPath";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import { NotificationManager } from "react-notifications";

function CreateNew() {
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [showRms, setShowRms] = useState(false);
  const [showShipment, setShowShipment] = useState(false);
  const [showOrderManagement, setShowOrderManagement] = useState(false);
  const [showOutstanding, setShowOutstanding] = useState(false);
  const [showUsers, setShowUsers] = useState(false);

  const handleRoleChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "Shipment":
        setShowShipment(checked);
        break;
      case "OrderManagement":
        setShowOrderManagement(checked);
        break;
      case "Outstanding":
        setShowOutstanding(checked);
        break;
      case "Users":
        setShowUsers(checked);
        break;
      case "Rms":
        setShowRms(checked);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    let data = await JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEY.user_token)
    );


    const headers = {
      // Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const body = {
      user_id: userId,
      name_of_user: name,
      Email: email,
      company_code: companyCode,
      company_name: companyName,
      show_rms: showRms,
      show_shipment: showShipment,
      show_OrderMangement: showOrderManagement,
      show_outstanding: showOutstanding,
      show_users: showUsers,
    };

    axios
      .post(`${HOST_URL}${path.CREATENEW}`, body, { headers })
      .then((res) => {
        NotificationManager.success(res?.data?.data, "", 3000);
      })
      .catch((err) => {
        console.error("Error:", err);
        NotificationManager.error(err?.data?.data, "", 3000);
      });
  };
  const handleClear = () => {
    setUserId("");
    setName("");
    setEmail("");
    setCompanyCode("");
    setCompanyName("");
    setShowRms(false);
    setShowShipment(false);
    setShowOrderManagement(false);
    setShowOutstanding(false);
    setShowUsers(false);
  };
  return (
    <div className="container-fluid _createcard">
      <h3>Create Users</h3>
      <div className="row _createorganization">
        <div className="col-4">
          <TextField
            label="User Id *"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
        <div className="col-4">
          <TextField
            label="Name*"
            value={name}
            onChange={(e) => setName(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
        <div className="col-4">
          <TextField
            label="Email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
      </div>

      <div className="row _createorganization">
        <div className="col-4">
          <TextField
            label="Company Code *"
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
        <div className="col-4">
          <TextField
            label="Company Name *"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            size="small"
            fullWidth
          />
        </div>
      </div>

      <div className="row _createorganization">
        <div className="col-12" style={{ display: "flex" }}>
          <FormControl>
            <FormLabel>
              <h5>User Role *</h5>
            </FormLabel>
            <div className="d-flex">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showShipment}
                    onChange={handleRoleChange}
                    name="Shipment"
                  />
                }
                label="Shipment"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showOrderManagement}
                    onChange={handleRoleChange}
                    name="OrderManagement"
                  />
                }
                label="Order Management"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showOutstanding}
                    onChange={handleRoleChange}
                    name="Outstanding"
                  />
                }
                label="Outstanding"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showUsers}
                    onChange={handleRoleChange}
                    name="Users"
                  />
                }
                label="Users"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showRms}
                    onChange={handleRoleChange}
                    name="Rms"
                  />
                }
                label="Rms"
              />
            </div>
          </FormControl>
        </div>
      </div>

      <div className="d-flex justify-content-center align-items-center">
        <Button className="me-3" onClick={handleSubmit}>Submit</Button>
        <Button onClick={handleClear}>Clear</Button>
      </div>
    </div>
  );
}

export default CreateNew;
